// hooks/useIsAdmin.js
import { useSelector } from "react-redux";

const useIsAdmin = () => {
  const userdata = useSelector(
    (state) => state.settings_data.profileSettings_data
  );
  const myOrganization = useSelector((state) => state.general?.myOrganization);
  const examiners = myOrganization?.examiners || [];

  const currentUser = examiners.find(
    (examiner) => examiner.id === userdata?.id
  );
  return currentUser?.role === "admin";
};

export default useIsAdmin;
